import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FacultySuccessMsgComponent } from '../faculty-success-msg/faculty-success-msg.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-add-faculty-popup',
  templateUrl: './add-faculty-popup.component.html',
  styleUrls: ['./add-faculty-popup.component.scss'],
})
export class AddFacultyPopupComponent  implements OnInit {
  addFacultyForm!: FormGroup;
  buttonColorName: any;



  constructor(private fb: FormBuilder, private dialog: MatDialog, public dialogRef: MatDialogRef<AddFacultyPopupComponent> ) { 
     this.buttonColorName = sessionStorage.getItem('buttonColorName');
  }

  ngOnInit() {
    this.addFaculty();
}

addFaculty() {
  this.addFacultyForm = this.fb.group({
    facultyName: ['', Validators.required],
    contactNumber: ['', [Validators.required, Validators.pattern('^[0-9]+$')]],
    email: ['', [Validators.required, Validators.email]],
    details: ['', Validators.required],
    link: ['', Validators.required]
  });
}

submitFaculty() {
  console.log('Submit button clicked');
  if (this.addFacultyForm.valid) {
    console.log('Form Submitted with Data:', this.addFacultyForm.value);
  this.dialogRef.close();
        const dialogRef = this.dialog.open(FacultySuccessMsgComponent, {
          disableClose: true,
          height: '25%',
          width: '30%',
          data: {
            msg:"Saved Succesfully!",
            btn2: 'OK',
            btn2BgColor: this.buttonColorName,
            showSuccessIcon: true,
            showSuccessMessage: false,
            showCloseIcon: false
          }
        });
        
        dialogRef.afterClosed().subscribe(() => {
        });
      }
}




closeDialog() {
  this.dialogRef.close();
}
}
